module.exports = __webpack_public_path__ + "static/img/wing_1250.b3a8d08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/wing_1250.jpg
// module id = 0BZv
// module chunks = 0